// Guest-owned source of truth for event page slug strings.
// Admin re-exports from here via its own enums/EventPageSlugs.ts for backward compatibility.
export const EVENT_PAGE_SLUGS = {
  Accommodations: 'accommodations',
  Custom: 'custom',
  Faq: 'faq',
  Guests: 'guests',
  Registry: 'registrylinks',
  Rsvp: 'rsvp',
  Schedule: 'schedule',
  Settings: 'settings',
  Story: 'story',
  ThingsToDo: 'things-to-do',
  Travel: 'travel',
  Video: 'video',
  Vip: 'vip',
  WeddingParty: 'weddingparty',
  Welcome: 'welcome',
} as const;

export type EventPageSlug = (typeof EVENT_PAGE_SLUGS)[keyof typeof EVENT_PAGE_SLUGS];
